__turbopack_context__.v({
  "cards": "LSQKeq_cards",
  "remark": "LSQKeq_remark",
});
